/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable import/no-unresolved */
import {
    Breadcrumb, Button, Panel, Tab, Tabs,
} from 'appkit-react';
import { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

import FR2052AAuditLogs from '../containers/FR2052AAuditLogs';
import '../styles/fr2052a.scss';
import FR2052AClassifyResult from './FR2052AClassifyResult';
import FR2052AComments from '../containers/FR2052AComments';
import FR2052AResultsAccordian from './FR2052AResultsAccordian';

const FR2052AResults = ({
    breadcrumbItems, onNavigate, columns, criteria, fetchData, data, pages, pagesize, setPageSize, setPageNumber, auditLog, refetch, pageSizeOptions,
}) => {
    const history = useHistory();
    const [showClassifyResult, setShowClassifyResult] = useState(false);
    return (
        <>

            <div className="true-comply-fr2052a-results_layout">
                <div className="true-comply-fr2052a-results_column-2">
                    <Breadcrumb items={breadcrumbItems} />
                    <Row>
                        <Col md={4}>
                            <div className="a-h2 title-label">
                                <span className="appkiticon icon-left-chevron-outline left-arrow-icon" onClick={() => history.goBack()} role="presentation" />
                                {`Rule #${(criteria && criteria.ruleId) ? criteria.ruleId : ''} Results`}
                            </div>
                        </Col>
                        <Col className="classyfy_btn_container">
                            <Row>
                                <Col style={{ textAlign: 'right' }}>
                                    <span>
                                        <Button size="lg" style={{ marginLeft: '1rem' }} onClick={() => setShowClassifyResult(true)}>
                                            CLASSIFY RESULTS
                                        </Button>
                                        {showClassifyResult
                                            && (
                                                <FR2052AClassifyResult
                                                    setShowClassifyResult={setShowClassifyResult}
                                                    refetch={auditLog.refetch}
                                                    refetchTestData={refetch}
                                                />
                                            )}
                                    </span>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    { /* import results accordian */ }
                    <FR2052AResultsAccordian
                        criteria={criteria}
                        columns={columns}
                        fetchData={fetchData}
                        data={data}
                        pages={pages}
                        pagesize={pagesize}
                        setPageSize={setPageSize}
                        setPageNumber={setPageNumber}
                        pageSizeOptions={pageSizeOptions}
                    />

                    <Panel style={{ marginTop: '1rem', marginBottom: '2rem' }}>
                        <Tabs defaultValue="2" className="a-tab-item-padding-10" size="md">
                            {/* <Tab value="1" label="REMEDIATION">
                                {remediation && remediation.length ? <Remediation failedTestsData={failedTestsData} refetch={auditLog.refetch} /> : (
                                    <div className="a-h4">
                                        Remediation is not allowed for passed test cases
                                    </div>
                                )}
                            </Tab> */}
                            <Tab value="2" label="COMMENTS">
                                <FR2052AComments refetch={auditLog.refetch} />
                            </Tab>
                            <Tab value="3" label="AUDIT LOG">
                                <FR2052AAuditLogs data={auditLog.data && auditLog.data.getAuditLogsForFR2052A} />
                            </Tab>
                        </Tabs>
                    </Panel>
                </div>
            </div>
        </>
    );
};

export default FR2052AResults;
